import React, { useEffect, useState } from 'react';
import axios from 'axios';

import './ProzessAnsicht.css';

const API_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

interface Nachricht {
  nachricht_id: number;
  rolle: string;
  inhalt: string;
  agent_genutzt?: string | null;
  erstellt_am: string | null;
}

interface Props {
  authToken: string;
  /** Konversation des Laufs; gelesen über /api/konversationen/{id} (für jeden Benutzer
   *  des Mandanten, nicht nur Admins wie /api/prozess-laeufe/{id}). */
  konversationId?: number | null;
  onClose?: () => void;
}

/** Read-only Protokoll eines Prozesslaufs: Nachrichten der Lauf-Konversation. */
const LaufProtokoll: React.FC<Props> = ({ authToken, konversationId, onClose }) => {
  const [nachrichten, setNachrichten] = useState<Nachricht[]>([]);
  const [loading, setLoading] = useState(true);
  const [fehler, setFehler] = useState('');

  useEffect(() => {
    let aktiv = true;
    const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
    (async () => {
      setLoading(true);
      setFehler('');
      try {
        const kid = konversationId ?? null;
        if (kid == null) {
          if (aktiv) setNachrichten([]);
          return;
        }
        const res = await axios.get(`${API_URL}/api/konversationen/${kid}`, { headers });
        if (aktiv) setNachrichten(res.data.nachrichten ?? []);
      } catch {
        if (aktiv) setFehler('Protokoll konnte nicht geladen werden.');
      } finally {
        if (aktiv) setLoading(false);
      }
    })();
    return () => {
      aktiv = false;
    };
  }, [authToken, konversationId]);

  return (
    <div className="pz-protokoll">
      <div className="pz-protokoll-kopf">
        <span className="pz-kette-label">Protokoll</span>
        {onClose && (
          <button type="button" className="k-btn k-btn--sm" onClick={onClose}>
            Schließen
          </button>
        )}
      </div>
      {loading ? (
        <div className="pz-leer">Lade Protokoll…</div>
      ) : fehler ? (
        <div className="pz-leer" style={{ color: 'var(--red)' }}>{fehler}</div>
      ) : nachrichten.length === 0 ? (
        <div className="pz-leer">Kein Protokoll vorhanden.</div>
      ) : (
        <ul className="pz-protokoll-liste">
          {nachrichten.map(n => (
            <li key={n.nachricht_id} className="pz-protokoll-eintrag">
              <div className="pz-protokoll-meta">
                {n.rolle}
                {n.agent_genutzt ? ` · ${n.agent_genutzt}` : ''}
                {n.erstellt_am ? ` · ${new Date(n.erstellt_am).toLocaleString('de-DE')}` : ''}
              </div>
              <div className="pz-protokoll-text">{n.inhalt}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LaufProtokoll;
